import Loader from "../../../common/components/Loader";
import Paginator from "../../../common/components/Paginator";
import { useEffect, useState } from "react";
import { ModalManageFolder } from "./modals/ModalManageFolder";
import FolderCalculsTable from "../containers/FolderCalculsTable";
import { BackArrow } from "../../../assets/icons/BackArrow";
import { history } from "../../../store/index";
import "./Folders.scss";
import { Pen } from "../../../assets/icons/Pen";
import SearchInput from "../../../common/components/SearchInput";
import CalculsFooterActions from "../../calcul/containers/CalculsFooterActions";
import { MFButton } from "../../../common/components/MFButton";
import { Filter } from "../../../assets/icons/Filter";
import { defaultCalculsFilters } from "../../calcul/constants";
import CalculsFilters from "../../calcul/containers/CalculsFilters";
import { CalculsFiltersBanner } from "../../calcul/components/filters/CalculsFiltersBanner";
import { normalizePaginationLimit } from "../../../common/constants/pagination";

const Folder = ({
  folderId,
  folderCalculs,
  isFoldersLoading,
  folderCalculsCurrentPage,
  loadFolderCalculs,
  changeFolderCalculsPage,
  folderCalculsLimit,
  updateFolderCalculsLimit,
  folderCalculsTotal,
  localConfigurator,
  updateFolder,
  folder,
  getFolder,
  getArchivedCalculs,
  folderCalculsSearch,
  changeFolderCalculsSearch,
  isGeneratingReports,
  isDownloadingReports,
  closeCalculsFiltersSection,
  calculsFilters,
  openCalculsFiltersSection,
  isFilterSectionOpen,
  folderCalculsFilters,
  updateFolderCalculsFilters,
}) => {
  const [isManageFolderModalOpen, setIsManageFolderModalOpen] = useState(false);
  const [selectedCalculs, setSelectedCalculs] = useState([]);
  const isArchivesFolder = folderId === "archives";
  const safeFolderCalculsLimit = normalizePaginationLimit(folderCalculsLimit);

  useEffect(() => {
    if (selectedCalculs.length === 0 || !folderCalculs?.length) return;
    setSelectedCalculs((prev) =>
      prev.map((selected) => {
        const updated = folderCalculs.find((c) => c._id === selected.id);
        if (!updated) return selected;
        return {
          ...selected,
          folderIds: updated.folders?.map((f) => f._id) || [],
        };
      }),
    );
  }, [folderCalculs]); // eslint-disable-line

  useEffect(() => {
    closeCalculsFiltersSection();
    if (!folderId) return;
    changeFolderCalculsPage(1, folderId);
    if (isArchivesFolder) {
      getArchivedCalculs();
    } else {
      loadFolderCalculs(folderId);
      getFolder(folderId);
    }
  }, [folderId]); // eslint-disable-line

  function handleFolderCalculsPageChange(page) {
    if (page === folderCalculsCurrentPage) return;
    changeFolderCalculsPage(page, folderId);
  }

  return (
    <div
      className={`custom-table-container folder-calcul-table ${selectedCalculs.length > 0 ? "has-calcul-footer" : ""}`}
    >
      <Loader
        isActive={
          isFoldersLoading ||
          (isGeneratingReports && selectedCalculs.length > 0) ||
          isDownloadingReports
        }
        text={
          isGeneratingReports
            ? "Génération en cours..."
            : isDownloadingReports
              ? "Téléchargement en cours..."
              : undefined
        }
      />
      <div className="table-inner-content">
        <div
          className="d-flex justify-content-between mt-2 mb-2 mx-1 align-items-center"
          style={{ minHeight: 48 }}
        >
          <div className="d-flex align-items-center">
            <button
              onClick={() => history.go(-1)}
              className="no-style"
              style={{ paddingLeft: 12 }}
            >
              <BackArrow size={24} className="text-black" />
            </button>
            <span className="ml-2 folder-label-header text-table-black">
              {isArchivesFolder ? "Archives" : folder?.label}
            </span>
            {!isArchivesFolder && (
              <button
                onClick={() => setIsManageFolderModalOpen(true)}
                className="no-style ml-1"
                style={{ paddingRight: 12 }}
              >
                <Pen className="text-interaction" />
              </button>
            )}
          </div>
          <div></div>
        </div>
        <div
          className="d-flex align-items-center search-input-container mx-1"
          style={{ marginBottom: 24 }}
        >
          <div className="w-100 mr-1">
            <SearchInput
              search={folderCalculsSearch}
              setSearch={(value) => changeFolderCalculsSearch(value, folderId)}
              placeholder="Rechercher un calcul"
            />
          </div>
          <MFButton
            height={38}
            outlined
            onClick={openCalculsFiltersSection}
            style={{ borderRadius: 6 }}
            className="d-flex align-items-center"
          >
            <span className="d-flex align-items-center position-relative">
              {JSON.stringify(folderCalculsFilters) !==
                JSON.stringify(defaultCalculsFilters) && (
                <div className="filter-button-badge text-interaction" />
              )}
              <Filter size={16} />
            </span>
            <span style={{ marginLeft: 8 }}>Filtrer</span>
          </MFButton>
        </div>
        <CalculsFiltersBanner
          folderId={folderId}
          filters={folderCalculsFilters}
          updateFilters={updateFolderCalculsFilters}
        />
        <FolderCalculsTable
          selectedCalculs={selectedCalculs}
          setSelectedCalculs={setSelectedCalculs}
        />
      </div>

      <div className="pagination-footer" style={{ height: 60 }}>
        <div className="flex-center">
          <span className="text-secondary-black text-nowrap mr-1">
            Par page
          </span>
          <select
            name="folder-calculs-per-page"
            className="form-control"
            value={safeFolderCalculsLimit}
            onChange={(event) => {
              updateFolderCalculsLimit(event.target.value, folderId);
            }}
          >
            {[10, 20, 30, 40, 50].map((value) => (
              <option key={"per-page" + value} value={value}>
                {value}
              </option>
            ))}
          </select>
        </div>
        <Paginator
          total={folderCalculsTotal}
          currentPage={folderCalculsCurrentPage}
          limit={safeFolderCalculsLimit}
          onPageChange={handleFolderCalculsPageChange}
          maxWidth={600}
        />
      </div>

      {selectedCalculs.length > 0 && (
        <CalculsFooterActions
          selectedCalculs={selectedCalculs}
          setSelectedCalculs={setSelectedCalculs}
          folderId={folderId}
        />
      )}
      <CalculsFilters
        folderId={folderId}
        filters={folderCalculsFilters}
        updateFilters={updateFolderCalculsFilters}
      />
      <ModalManageFolder
        isOpen={isManageFolderModalOpen}
        onClose={() => setIsManageFolderModalOpen(false)}
        updateFolder={updateFolder}
        folder={folder}
      />
    </div>
  );
};

export default Folder;
